import { render } from "./MyIntro.vue?vue&type=template&id=8669564e&scoped=true"
import script from "./MyIntro.vue?vue&type=script&lang=js"
export * from "./MyIntro.vue?vue&type=script&lang=js"

import "./MyIntro.vue?vue&type=style&index=0&id=8669564e&scoped=true&lang=scss"

import exportComponent from "/srv/http/cv.mzubiaga.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8669564e"]])

export default __exports__